import { useRef, useEffect } from 'react';

/**
 * Returns the previous value of a variable.
 * @param {*} value The value to track.
 * @returns {*} The previous value of the variable.
 */
export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
